import { sendToApi } from 'api/client'
import { ArticleFlat } from 'types'

export const SnapshotClient = {
  getSnapshot: async (articleKey: string, version: number, layerId?: string) => {
    return sendToApi<{ article: ArticleFlat }>(`/articles/${articleKey}/snapshots/${version}`, {
      params: { layer_id: layerId },
    })
  },
}
